import { FC, useContext, useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import useLogout from "../../hooks/useLogout";
import { ToastContext } from "src/context/toastContext";
import { ToastTypes } from "src/types";
// import { formatTime } from "src/helpers/session";

const IdleSession: FC<{ idleTime: number }> = ({ idleTime }) => {
  const [isSessionExpired, setSessionExpired] = useState<boolean>(false);
  const { logoutUser } = useLogout();
  const { showToast } = useContext(ToastContext);

  // Called when user becomes idle (no activity for idleTime)
  const onIdleAction = () => {
    setSessionExpired(true);
  };

  // Called when user becomes active again after idle
  const onActiveAction = () => {
    if (isSessionExpired) {
      setSessionExpired(false);
      showToast(
        ["Your session has expired. Please login again to continue"],
        ToastTypes.ERROR
      );
      logoutUser(true);
    }
  };

  // Initialize idle timer
  // const { getRemainingTime } = 
  useIdleTimer({
    timeout: idleTime <= 0 ? 1 : idleTime,
    throttle: 500,
    crossTab: true,
    startOnMount: true,
    startManually: false,
    onActive: onActiveAction,
    onIdle: onIdleAction,
  });

  // Handle tab close / leave site / re-entry after long time
  useEffect(() => {
    const momentKey = "momentTimeLogged";

    const storeCurrentTime = () => {
      localStorage.setItem(momentKey, new Date().toISOString());
    };

    const checkIfExpiredOnLoad = () => {
      const lastTime = localStorage.getItem(momentKey);
      if (lastTime) {
        const diff = Date.now() - new Date(lastTime).getTime();
        if (diff > idleTime) {
          // Session expired while user was away
          showToast(
            ["Your session has expired. Please login again to continue"],
            ToastTypes.ERROR
          );
          logoutUser(true);
        }
      }
    };

    // Check once on component mount
    checkIfExpiredOnLoad();

    // Update timestamp every minute while active
    const interval = setInterval(storeCurrentTime, 60 * 1000);

    // Store latest time before leaving the page
    window.addEventListener("beforeunload", storeCurrentTime);

    // Log remaining time for debugging
    // const timer = setInterval(() => {
    //   console.log({ remainingTime: formatTime(getRemainingTime()) });
    // }, 1000);

    return () => {
      // clearInterval(timer);
      clearInterval(interval);
      window.removeEventListener("beforeunload", storeCurrentTime);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default IdleSession;
